import React from 'react';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import { useGetUser } from '../user/useAllUsers';
import Link from '../utils/router/Link';
import userPath from '../utils/url/userPath';
import Activity from './Activity';
import ActivityPostCard from './ActivityPostCard';
import activitiesPostTopics from './activitiesPostTopics';

const ACTIVITY_PUBLISHED_POST_ACTIVITY_FRAGMENT = gql(`
  fragment ActivityPublishedPost_activity on PublishedPostActivity {
    actedAt
    actor {
      ...useGetUser_user
    }
    publishedPost {
      id
      topics {
        ...activitiesPostTopics_topics
      }
      ...ActivityPostCard_post
    }
  }
`);

interface ActivityPublishedPostProps {
  activity: DocumentType<typeof ACTIVITY_PUBLISHED_POST_ACTIVITY_FRAGMENT>;
}

const ActivityPublishedPost = ({ activity }: ActivityPublishedPostProps) => {
  const { actedAt, publishedPost } = activity;

  const getUser = useGetUser();

  if (!activity.actor) {
    return null;
  }

  const actor = getUser(activity.actor);

  return (
    <Activity
      actor={actor}
      actedAt={actedAt}
      action="POST_PUBLISH"
      title={
        <>
          <Link to={userPath(actor)}>{actor.name}</Link> published a post
        </>
      }
      meta={activitiesPostTopics(publishedPost ? publishedPost.topics : null)}
    >
      {publishedPost ? (
        <ActivityPostCard post={publishedPost} maxLines={4} />
      ) : null}
    </Activity>
  );
};

export default ActivityPublishedPost;
